import commonButtonStyles from '../../multimediaButtons/buttonWrapper/button/common/MultimediaButtonCommon.module.css'
import attachmentListStyles from '../AttachmentsList.module.css'
import MultimediaButtonLoadingContent from '../../multimediaButtons/buttonWrapper/button/common/MultimediaButtonLoadingContent'
import React from 'react'
import { getMultimediaUniqueKey } from '../picture/PictureList'
import { useTranslation } from 'react-i18next'
import { AttachmentData, AttachmentStatus, AttachmentType } from '../../../../../../../../@types/types'

const UploadingList = ({
  attachments,
  attachmentType,
}: {
  attachments: AttachmentData[]
  attachmentType: AttachmentType
}) => {
  const titleTranslationKey = attachmentType === AttachmentType.PICTURE ? 'pictures.title' : 'documents.title'
  return attachments
    .filter((it) => it.state === AttachmentStatus.UPLOADING && it.attachmentType === attachmentType)
    .map((it, index) => (
      <Uploading
        attachment={it}
        titleTranslationKey={titleTranslationKey}
        key={it.attachment?.id || '' + index + '-uploading'}
      />
    ))
}

const Uploading: React.FC<{
  attachment: AttachmentData
  titleTranslationKey: string
}> = ({ attachment, titleTranslationKey }) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'wizard.screen.multimediaNew.buttons' })

  return (
    <div className='grid-item one-half'>
      <div
        className={`${commonButtonStyles.button} ${commonButtonStyles.buttonDisabled} ${attachmentListStyles.attachmentContainer} align-left border-radius-rounded`}
      >
        <MultimediaButtonLoadingContent
          key={`${getMultimediaUniqueKey(attachment)}'-loading'`}
          title={`${t(titleTranslationKey)}`}
          subtitle={`${t(`common.attachmentUploadingMessage`)} ${attachment.file!.percent!} %`}
        />
      </div>
    </div>
  )
}

export default UploadingList
